@if (freight.id !== undefined && freight.id !== '' && freight.stopsBasic.length > 0) {
  <ion-card
    button="true"
    [routerLink]="['/posted-freight', freight.id]"
    routerDirection="root"
    routerLinkActive="active"
    [ngClass]="{
      cancelled: freight.status === EFreightStatus.CANCELLED,
    }"
  >
    <ion-card-content>
      <ion-row>
        <ion-col
          size="12"
          [sizeLg]="2"
          class="ion-no-padding"
        >
          <div class="reference">
            <div>
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/qr_code_24dp.svg"
              ></ion-icon>
              <p>
                <strong>{{ freight.reference }}</strong>
              </p>
            </div>
            <div>
              <!-- TODO okcargo reference, to add in IFreightBasicForShipper-->
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/barcode_24dp.svg"
              ></ion-icon>
              <p>
                <strong>{{ freight.reference }}</strong>
              </p>
            </div>
            <div>
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/pin_drop_24dp.svg"
              ></ion-icon>
              <p>
                <strong>{{ freight.numberOfStops }}</strong>
              </p>
            </div>

            @if (freight.status === EFreightStatus.CANCELLED) {
              <div class="cancelled-tag">
                <span>
                  {{ 'general.cancelled' | translate }}
                </span>
              </div>
            }
          </div>
        </ion-col>

        <ion-col
          size="6"
          [sizeLg]="4"
        >
          <div class="step step--to-upload">
            <ion-icon
              slot="start"
              aria-hidden="true"
              src="../assets/material-symbols/upload_24dp.svg"
            ></ion-icon>
            <div class="">
              <strong
                >({{ freight.stopsBasic[0].address.countryCode }})
                {{
                  `states.${freight.stopsBasic[0].address.countryCode}${freight.stopsBasic[0].address.stateCode}`
                    | translate
                }}
              </strong>
            </div>
          </div>
          <div class="address">
            <div>
              <p class="company">
                {{ freight.stopsBasic[0].address.company }}
              </p>
              <p class="city">
                {{ freight.stopsBasic[0].address.postalCode }} {{ freight.stopsBasic[0].address.city }}
              </p>
            </div>
            <p class="date">
              {{ freight.stopsBasic[0].since | dfnsFormat: 'ccc Pp' }}
            </p>
          </div>
        </ion-col>

        <ion-col
          size="6"
          [sizeLg]="4"
        >
          <div class="step step--to-download">
            <ion-icon
              slot="start"
              aria-hidden="true"
              src="../assets/material-symbols/download_24dp.svg"
            ></ion-icon>
            <div class="">
              <strong>
                ({{ freight.stopsBasic[freight.stopsBasic.length - 1].address.countryCode }})
                {{
                  `states.${freight.stopsBasic[freight.stopsBasic.length - 1].address.countryCode}${freight.stopsBasic[freight.stopsBasic.length - 1].address.stateCode}`
                    | translate
                }}
              </strong>
            </div>
          </div>
          <div class="address">
            <div>
              <p class="company">
                {{ freight.stopsBasic[freight.stopsBasic.length - 1].address.company }}
              </p>
              <p class="city">
                {{ freight.stopsBasic[freight.stopsBasic.length - 1].address.postalCode }}
                {{ freight.stopsBasic[freight.stopsBasic.length - 1].address.city }}
              </p>
            </div>
            <p class="date">
              {{ freight.stopsBasic[freight.stopsBasic.length - 1].since | dfnsFormat: 'ccc Pp' }}
            </p>
          </div>
        </ion-col>

        @if (freight.price || (freight.vehicles && freight.vehicles.length > 0)) {
          <ion-col
            size-lg="2"
            size="12"
            class="more-info"
          >
            @if (freight.price) {
              <p class="fs-xs">
                <ion-icon
                  slot="start"
                  aria-hidden="true"
                  src="../assets/material-symbols/payments_24dp.svg"
                ></ion-icon>
                <strong>{{ freight.price | number: '1.2-2' }} €</strong>
              </p>
              @if (freight.status === EFreightStatus.OFFER_SENT) {
                <lib-price-acceptance-buttons [freight]="freight"></lib-price-acceptance-buttons>
              }
            }
            @if (freight.vehicles && freight.vehicles.length > 0) {
              <p class="fs-xs">
                <ion-icon
                  slot="start"
                  aria-hidden="true"
                  src="../assets/material-symbols/local_shipping_24dp.svg"
                ></ion-icon>
                {{ printVehicles(freight.vehicles) }}
              </p>
            }
          </ion-col>
        }
      </ion-row>
    </ion-card-content>
  </ion-card>
}
